export default "__VITE_ASSET__BDwxvgKA__"